import { Box } from '@mui/material';
import { useMemo } from 'react';

type DataGridHeaderProps = {
  flexDirection?: 'row' | 'column';
  children: React.ReactNode;
};

const DataGridHeader = ({ flexDirection, children }: DataGridHeaderProps) => {
  const styles = useMemo(
    () => ({
      width: '100%',
      maxHeight: '136px',
      height: '100%',
      paddingTop: '8px',
      paddingBottom: '8px',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: flexDirection || 'column',
      justifyContent: 'space-between',
      gap: '24px',
    }),
    [flexDirection],
  );
  return <Box sx={styles}>{children}</Box>;
};

export { DataGridHeader };
export type { DataGridHeaderProps };
